<template>
    <div>
        <h5>{{group.name}}</h5>

        <app-property v-for="property of group.properties" :key="property.id" :property="property"/>

        <hr/>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import AppProperty from "@/components/expert/AppProperty.vue";
    import {Group} from "@/entities/questionaire/Group";

    @Component({
        components: {
            AppProperty: AppProperty,
        },
    })
    export default class AppGroup extends Vue{
        @Prop()
        group?: Group;
    }
</script>

<style scoped>
</style>
